import { Rule } from '@core/models/attendance/rule';
import { IEntitiesState, initialEntitiesState } from './entities-state';
import { entitiesListReducer } from './entities-list-reducer';
import { Connection } from '@core/models/connection/connection';
import { CONNECTION_PERMISSIONS_RELATION_SET, CONNECTION_POSITIONS_DELETE, LOCATION_ENTITY_SET, LOCATION_RULES_UPDATE } from '@core/state/action-types';

export function reducer(state = initialEntitiesState(), action: any): IEntitiesState {

    switch (action.type) {
        

        case CONNECTION_PERMISSIONS_RELATION_SET:
            return {
                ...state,
                relationships: {
                    ...state.relationships,
                    connectionPermissions: {
                        ...state.relationships.connectionPermissions,
                        [action.payload.relatedId]: action.payload.itemIds
                    }
                }
            };

        case CONNECTION_POSITIONS_DELETE:
            const updatedConnection: Connection = state.entities.connection[action.payload.id];
            updatedConnection.skills = updatedConnection.skills.filter((skill) => !action.payload.skills.includes(skill.id));

            return {
                ...state,
                entities: {
                    ...state.entities,
                    connection: {
                        ...state.entities.connection,
                        [action.payload.connectionId]: updatedConnection
                    }
                }
            };

        

        case LOCATION_ENTITY_SET:
            const { location } = action.payload;
            return {
                ...state,
                entities: {
                    ...state.entities,
                    location: {
                        ...state.entities.location,
                        [location.id]: location
                    }
                }
            };

        

        case LOCATION_RULES_UPDATE:
            const { locationId, rules } = action.payload;
            const existingRule: Rule = state.entities.locationRule[locationId];

            return {
                ...state,
                entities: {
                    ...state.entities,
                    locationRule: {
                        ...state.entities.locationRule,
                        [locationId]: Object.assign(new Rule(), existingRule, rules)
                    }
                }
            };

        

        default:
            let nextState: IEntitiesState = state;
            if (action.payload && action.payload.domain) {
                const { domain } = action.payload;
                nextState = {
                    ...state,
                    entities: {
                        ...state.entities,
                        [domain]: entitiesListReducer(state.entities[domain], action)
                    }

                };
            }

            return nextState;
    }
}